
import fetch from '@/utils/fetch'
import {API_PATH} from '@/config/env'
export const userLogin = (objJson, flag) => {
  // 判断是实操登录还是普通登录
  let url = flag ? '/exam/api/practicalUser/practicalUserLogin' : '/user/api/user/login/password'
  //
  return fetch(API_PATH + url, objJson, 'POST')
}
export const userRegist = (objJson) => fetch(API_PATH + '/user/api/user/register', objJson, 'POST')
export const sendCode = (objJson) => fetch(API_PATH + '/user/api/user/send/code', objJson, 'POST')
export const updataPass = (objJson) => fetch(API_PATH + '/user/api/user/update/password', objJson, 'POST')
export const studylog = (objJson) => fetch(API_PATH + '/course/api/course/user/study/log/list', objJson, 'POST')
export const studyRecords = (objJson) => fetch(API_PATH + '/course/auth/certificate/study/logs', objJson, 'POST')
export const studyPlan = (objJson) => fetch(API_PATH + '/course/auth/study/plan/list', objJson, 'POST')
export const selectPlans = (objJson) => fetch(API_PATH + '/course/auth/study/plan/name', objJson, 'POST')
export const checkUser = (objJson) => fetch(API_PATH + '/user/api/user/queryMobile', objJson, 'POST')
export const updateMobile = (objJson) => fetch(API_PATH + '/user/api/user/updateMobile', objJson, 'POST')
export const AccessToken = (objJson) => fetch(API_PATH + '/system/auth/sys/getAccessToken', objJson, 'POST')
// 下单
export const orderPay = (objJson) => fetch(API_PATH + '/user/pre_pay/order/pay', objJson, 'POST')
// export const orderPay = (objJson) => fetch(API_PATH + '/user/api/order/pay', objJson, 'POST')
// 订单查询结果
export const wxPayAppResult = (objJson) => fetch(API_PATH + '/user/pre_pay/order/wxPayAppResult', objJson, 'POST')
// 微信订单结果
export const getwxPayAppResult = (objJson) => fetch(API_PATH + '/user/pre_pay/order/getwxPayAppResult', objJson, 'POST')
// 修改密码
export const updataPassNew = (objJson) => fetch(API_PATH + '/user/api/user/student/update/password', objJson, 'POST')
// 成功订单列表查询
export const orderSucList = (objJson) => fetch(API_PATH + '/user/auth/order/select', objJson, 'POST')
// 查询订单金额
export const selectFee = (objJson) => fetch(API_PATH + '/user/pre_pay/order/selectFee', objJson, 'POST')



// WEBPACK FOOTER //
// ./src/api/person.js